import { http } from '@/api/client/httpClient';
import type { SelectListItem } from '@/api/types/traderSurveillance';

// Finkit.CommonServices.Global.Currencies.CurrencyAppService
//   GetCurrenciesSelectListAsync(tenantId) -> GET /api/app/currency/currencies-select-list/{tenantId}
// ABP routes the single primitive param into the PATH (not ?tenantId=) — verified
// against /api/abp/api-definition. Value = currency symbol, Text = currency name.
const BASE = '/api/app/currency';

export const currencyApi = {
  getCurrenciesSelectList: (tenantId: string) =>
    http.get<SelectListItem[]>(`${BASE}/currencies-select-list/${encodeURIComponent(tenantId)}`).then((r) => r.data),
};
